// extracted by css-extract-rspack-plugin
export default {"icon":"JKqRaRvkc945vajP","tag":"mPgg5zA6feky3Y85"};